import React from 'react';
import About from './About';
import Hero from './Hero';
import Works from './Works';

interface IHomeProps {
  children?: React.ReactNode;
}

const Home:React.FC<IHomeProps> = (props) => {
  return (
    <>
      <Hero />
      <About />
      <Works />
    </>
  );
}

export default Home;
